<script setup lang="ts">
import ButtonRegular from './ButtonRegular.vue'

defineProps({
  size: {
    type: String as () => '50' | '44' | '32',
    default: '44',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <ButtonRegular
    class="rounded-12 bg-blupur text-white enabled:active:bg-[#46057c]"
    :size="size"
    :disabled="disabled"
  >
    <slot />
  </ButtonRegular>
</template>
